import React from "react";
import { Flex } from "../Box";
import { ProjectsStyle } from "./styles";

const works = [
  {
    name: "Aegle Health - Talk to a doctor 24/7 ",
    description:
      "Worked for Team Grace Health Services Limited to collabote with their deveopers to build a mobile version of their App.",
    source: "https://play.google.com/store/apps/details?id=com.medical_new",
  },
  {
    name: "Aegle Doctor",
    description:
      "Doctor App for Aegle Health",
    source: "https://play.google.com/store/apps/details?id=com.aegle_doctor",
  },
  {
    name: "Garble App",
    description:
      "Waste Management App",
    source: "https://drive.google.com/open?id=1hL8nG9Du-agHYTZXBqNA4Y2N4YNozp_N",
  },
];
const works1 = [
  {
    name: "Motosellers",
    description:
      "Web App for car e-commerce.",
    source: "https://motosellers.com/",
  },
  {
    name: "SureGift",
    description:
      "A gifting company. Joined team to redesign their App",
    source: "https://suregifts.com.ng/",
  },
  {
    name: "Learnfactory website",
    description:
      "LearnFactory Nigeria website",
    source: "https://learnfactory.com.ng/",
  },
  {
    name: "EmBED",
    description:
      "A platform for gamifying educational learning",
    source: "https://embed.ng/",
  },
];
const Menu = () => {

  return (
    <ProjectsStyle>
      <Flex className="container" width="55%">
        <div className='sub-container drops'>
          <p className="lightText title">Here are some projects I've worked on:</p>
          <div>
          <p className="lightText mt title">Mobile Apps:</p>
            <ul>
              {works.map(({ name, description, source }) => (
                <li>
                  <h3 className="lightText">{name}</h3>
                  <p className="greyedText">{description}</p>
                  <div className="source">
                    <a href={source} className="darkText">
                      View
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div>
          <p className="lightText mt title">Web Apps:</p>
            <ul>
              {works1.map(({ name, description, source }) => (
                <li>
                  <h3 className="lightText">{name}</h3>
                  <p className="greyedText">{description}</p>
                  <div className="source">
                    <a href={source} className="darkText">
                      View
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Flex>
    </ProjectsStyle>
  );
};
export default Menu;
